<template>
  <div class="the-header" :class="`header-${lang}`">
    <header id="header">
      <div class="container">
        <div class="relative-section">
          <span class="hotline">
            <b>{{ general.hotline }}</b>
            {{ general.working_time }}
          </span>
          <div class="header-middle text-center font-bold font-balo">
            <div class="list-inline">
              <div class="item-inline menu-main menu-left">
                <ul>
                  <li v-for="(item, index) in menuLeft" :key="index">
                    <router-link :to="item.path" v-if="!item.children" v-html="item.title"></router-link>
                    <a href @click.prevent v-if="item.children" v-html="item.title"></a>
                    <div
                      class="sub-menu"
                      v-if="
                                                item.children &&
                                                    item.children.length
                                            "
                    >
                      <ul>
                        <li
                          v-for="(itemChild,
                                                    indexChild) in item.children"
                          :key="indexChild"
                        >
                          <a
                            href
                            v-if="itemChild.object === 'camping_club'"
                            v-html="itemChild.title"
                            @click.prevent="
                                                            onGetCampingClub(
                                                                itemChild.object_id
                                                            )
                                                        "
                          ></a>
                          <a
                            :href="itemChild.url"
                            v-if="itemChild.object === 'custom' && itemChild.url"
                            v-html="itemChild.title"
                          ></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
              <div class="item-inline">
                <router-link to="/" href class="logo header-logo">
                  <img :src="general.logo" v-if="general.logo" />
                  <img src="../assets/images/logo/logo.png" alt v-if="!general.logo" />
                </router-link>
              </div>
              <div class="item-inline menu-main menu-right">
                <ul>
                  <li v-for="(item, index) in menuRight" :key="index">
                    <a :href="generateRouter(item)" v-if="!item.children" v-html="item.title"></a>
                    <a @click.prevent v-if="item.children" v-html="item.title"></a>
                    <div
                      class="sub-menu"
                      v-if="
                                                item.children &&
                                                    item.children.length
                                            "
                    >
                      <ul>
                        <li
                          v-for="(itemChild,
                                                    indexChild) in item.children"
                          :key="indexChild"
                        >
                          <a v-html="itemChild.title" :href="generateRouter(itemChild)"></a>
                        </li>
                      </ul>
                    </div>
                  </li>
                </ul>
              </div>
            </div>
          </div>
          <a href class="toggle-menu" @click.prevent="toggleMenu()">
            <img src="../assets/images/menu.png" alt />
          </a>
          <div class="menu-transform"></div>
          <div class="menu-mobile font-bold font-balo" :class="{ active: isShowMenuMobile }">
            <div class="menu-inner">
              <a href class="menu-close" @click.prevent="toggleMenu()">
                <img src="../assets/images/menu-close.png" alt />
              </a>
              <div class="wrapper-language-currency">
                <div class="languages">
                  <div
                    class="wpml-ls-statics-shortcode_actions wpml-ls wpml-ls-legacy-dropdown js-wpml-ls-legacy-dropdown"
                  >
                    <ul>
                      <li
                        tabindex="0"
                        class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-en wpml-ls-current-language wpml-ls-first-item wpml-ls-item-legacy-dropdown"
                      >
                        <a
                          href="#"
                          class="js-wpml-ls-item-toggle wpml-ls-item-toggle"
                          @click.prevent="
                                                        setIsOpenDropdown(
                                                            'language'
                                                        )
                                                    "
                        >
                          <span class="wpml-ls-native">{{ lang }}</span>
                        </a>
                        <slide-up-down
                          :active="
                                                        isOpenDopdown ===
                                                            'language'
                                                    "
                          tag="ul"
                          :duration="100"
                          class="wpml-ls-sub-menu"
                        >
                          <li
                            class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-vi wpml-ls-last-item"
                            v-for="(lang,
                                                        index) in langs"
                            :key="index"
                          >
                            <a
                              href
                              class="wpml-ls-link"
                              @click.prevent="
                                                                onChangeLang(
                                                                    lang
                                                                )
                                                            "
                            >
                              <span class="wpml-ls-display">
                                {{
                                lang
                                }}
                              </span>
                            </a>
                          </li>
                        </slide-up-down>
                      </li>
                    </ul>
                  </div>
                </div>
                <div class="languages mobile-currencies">
                  <div
                    class="wpml-ls-statics-shortcode_actions wpml-ls wpml-ls-legacy-dropdown js-wpml-ls-legacy-dropdown"
                  >
                    <ul>
                      <li
                        tabindex="0"
                        class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-en wpml-ls-current-language wpml-ls-first-item wpml-ls-item-legacy-dropdown"
                      >
                        <a
                          href="#"
                          class="js-wpml-ls-item-toggle wpml-ls-item-toggle"
                          @click.prevent="
                                                        setIsOpenDropdown(
                                                            'currency'
                                                        )
                                                    "
                        >
                          <span class="wpml-ls-native">{{ currency.symbol }}</span>
                        </a>
                        <slide-up-down
                          :active="
                                                        isOpenDopdown ===
                                                            'currency'
                                                    "
                          tag="ul"
                          :duration="100"
                          class="wpml-ls-sub-menu"
                        >
                          <li
                            class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-vi wpml-ls-last-item"
                            v-for="(currency,
                                                        index) in currencies"
                            :key="index"
                          >
                            <a
                              href
                              class="wpml-ls-link"
                              @click.prevent="
                                                                onChangeCurrency(
                                                                    currency
                                                                )
                                                            "
                            >
                              <span class="wpml-ls-display">
                                {{
                                currency.symbol
                                }}
                              </span>
                            </a>
                          </li>
                        </slide-up-down>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="menu-main-mobile">
                <ul>
                  <template v-for="(item, index) in menuLeft">
                    <li
                      :class="{'menu-has-child': item.children}"
                      v-if="item.children"
                      :key="`left-menu-${index}`"
                    >
                      <a href @click.prevent="toggleSubMenu(item)" v-if="!item.path">
                        <span v-html="item.title"></span>
                        <i class="fa fa-plus"></i>
                      </a>
                      <slide-up-down
                        class="sub-menu"
                        v-if="item.children"
                        :active="isActiveSubMenu === item.ID"
                        :duration="300"
                      >
                        <ul>
                          <li v-for="(itemChild, indexChild) in item.children" :key="indexChild">
                            <a
                              href
                              v-if="itemChild.object === 'camping_club'"
                              @click.prevent="
                                                            onGetCampingClub(
                                                                itemChild.object_id
                                                            )
                                                        "
                              v-html="itemChild.title"
                            ></a>
                            <a
                              :href="itemChild.url"
                              v-if="itemChild.object === 'custom' && itemChild.url"
                              v-html="itemChild.title"
                            ></a>
                          </li>
                        </ul>
                      </slide-up-down>
                    </li>
                    <li @click="toggleMenu()" v-if="!item.children" :key="`left-menu-${index}`">
                      <router-link :to="item.path" v-html="item.title"></router-link>
                    </li>
                  </template>
                  <template v-for="(item, index) in menuRight">
                    <li
                      :class="{'menu-has-child': item.children}"
                      v-if="item.children"
                      :key="`right-menu-${index}`"
                    >
                      <a @click.prevent="toggleSubMenu(item)">
                        <span v-html="item.title"></span>
                        <i class="fa fa-plus"></i>
                      </a>
                      <slide-up-down
                        class="sub-menu"
                        v-if="item.children"
                        :active="isActiveSubMenu === item.ID"
                        :duration="300"
                      >
                        <ul>
                          <li v-for="(itemChild, indexChild) in item.children" :key="indexChild">
                            <a :href="generateRouter(itemChild)" v-html="itemChild.title"></a>
                          </li>
                        </ul>
                      </slide-up-down>
                    </li>
                    <li @click="toggleMenu()" v-if="!item.children" :key="`right-menu-${index}`">
                      <a :href="generateRouter(item)" v-html="item.title"></a>
                    </li>
                  </template>
                  <li @click="toggleMenu()">
                    <router-link to="/contact-us" class="contact-link">
                      {{ $t("header.Contactez-nous") }}
                      !
                    </router-link>
                  </li>
                </ul>
              </div>
              <span class="hotline">
                <b>{{ general.hotline }}</b>
                {{ general.working_time }}
              </span>
            </div>
          </div>
          <div class="header-right font-balo font-bold">
            <div class="list-inline">
              <div class="item-inline">
                <router-link
                  to="/"
                  href
                  class="cart-link relative-section font-balo"
                  v-if="!cart.room"
                ></router-link>
                <router-link
                  to="/cart"
                  href
                  class="cart-link relative-section font-balo"
                  v-if="cart.room"
                >
                  <b>1</b>
                </router-link>
              </div>
              <div class="item-inline">
                <router-link to="/contact-us" class="contact-link">
                  {{ $t("header.Contactez-nous") }}
                  !
                </router-link>
              </div>
              <div class="item-inline">
                <div class="languages">
                  <div
                    class="wpml-ls-statics-shortcode_actions wpml-ls wpml-ls-legacy-dropdown js-wpml-ls-legacy-dropdown"
                  >
                    <ul>
                      <li
                        tabindex="0"
                        class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-en wpml-ls-current-language wpml-ls-first-item wpml-ls-item-legacy-dropdown language-select"
                      >
                        <a
                          href="#"
                          class="js-wpml-ls-item-toggle wpml-ls-item-toggle"
                          @click.prevent
                        >
                          <span class="wpml-ls-native">{{ lang }}</span>
                        </a>
                        <ul class="wpml-ls-sub-menu">
                          <li
                            class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-vi wpml-ls-last-item"
                            v-for="(lang,
                                                        index) in langs"
                            :key="index"
                          >
                            <a
                              href
                              class="wpml-ls-link"
                              @click.prevent="
                                                                onChangeLang(
                                                                    lang
                                                                )
                                                            "
                            >
                              <span class="wpml-ls-display">{{ lang }}</span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
              <div class="item-inline">
                <div class="languages currencies">
                  <div
                    class="wpml-ls-statics-shortcode_actions wpml-ls wpml-ls-legacy-dropdown js-wpml-ls-legacy-dropdown"
                  >
                    <ul>
                      <li
                        tabindex="0"
                        class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-en wpml-ls-current-language wpml-ls-first-item wpml-ls-item-legacy-dropdown"
                      >
                        <a class="js-wpml-ls-item-toggle wpml-ls-item-toggle" @click.prevent>
                          <span class="wpml-ls-native">{{ currency.symbol }}</span>
                        </a>
                        <ul class="wpml-ls-sub-menu">
                          <li
                            class="wpml-ls-slot-shortcode_actions wpml-ls-item wpml-ls-item-vi wpml-ls-last-item"
                            v-for="(item,
                                                        index) in currencies"
                            :key="index"
                          >
                            <a
                              href
                              class="wpml-ls-link"
                              @click.prevent="
                                                                onChangeCurrency(
                                                                    item
                                                                )
                                                            "
                            >
                              <span class="wpml-ls-display">
                                {{
                                item.symbol
                                }}
                              </span>
                            </a>
                          </li>
                        </ul>
                      </li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </header>
  </div>
</template>

<script>
import { languages } from "@/plugins/i18n";
import { mapMutations, mapState } from "vuex";
import { get, includes } from "lodash";
import { currencies } from "@/helper/config";
export default {
  name: "HeaderComponent",
  data() {
    return {
      isShowMenuMobile: false,
      isActiveSubMenu: false,
      langs: languages,
      currencies: currencies,
      isOpenDopdown: null
    };
  },
  computed: {
    ...mapState({
      campingClubs: state => get(state, "campingClubs.list", []),
      lang: state => get(state, "app.lang", false),
      general: state => get(state, "app.general", {}),
      currency: state => get(state, "app.currency"),
      cart: state => get(state, "cart.cart", null),
      menuLeft: state => get(state, "app.menu.menuLeft", []),
      menuRight: state => get(state, "app.menu.menuRight", [])
    })
  },
  methods: {
    ...mapMutations("app", ["setLang", "setCurrency"]),
    onChangeLang(lang) {
      this.isOpenDopdown = null;
      this.setLang(lang);
      location.reload();
      return;
    },
    toggleMenu() {
      this.isShowMenuMobile = !this.isShowMenuMobile;
    },
    onGetCampingClub(campingId) {
      const currentCampingId = this.$route.params.id;
      if (Number(currentCampingId) !== Number(campingId)) {
        this.$router.push(`/camping/${campingId}`);
      }
      this.toggleMenu();
    },
    onChangeCurrency(currency) {
      this.setCurrency(currency);
      this.isOpenDopdown = null;
    },
    setIsOpenDropdown(isOpenDopdown) {
      this.isOpenDopdown =
        this.isOpenDopdown == isOpenDopdown ? null : isOpenDopdown;
    },
    toggleSubMenu(item) {
      this.isActiveSubMenu = this.isActiveSubMenu === item.ID ? null : item.ID;
    },
    generateRouter(item) {
      let path = item.path;
      if (item.object === "page" && !includes(["/faq"], item.path)) {
        path = `/page${item.path}`;
      }
      return path;
    }
  }
};
</script>
